import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PressItem from '../elements/press_item.js';
import kit from '../../images/wmgr_presentation_assets/wmgr_concept_elements/wmgr_kit.png';
import {
    Alignment,
    Button,
    Classes,
    H5,
    Navbar,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
    Switch,
    ContextMenuTarget,
} from "@blueprintjs/core";
import { Player } from 'video-react';



class Press extends Component {
  constructor(props) {
    super(props);
    this.visitYahooFin = this
        .visitYahooFin
        .bind(this);
}
  investor_data = {
    description: "The Wellness Matrix Group's market strategy is targeting the expanding, aging, millennium segment of the medical industry, with patented big data collection software, and virtual reality/artificial Intelligence utilization. The Company sees an opportunity to be first to use up-to-the-minute scientific analytics, advanced statistics, and machine learning to authenticate and validate source data, monitor body functions, analyze and optimize outcomes, protocols and treatments from both alternative and traditional medical models. Wellness Matrix Group's research shows that humans can live longer if they take advantage of the latest wave of technical advances afforded by the internet. Subscribers, depending on the program level the user has subscribed, will receive services up to a lifetime. The technology will be be real-time minute-by-minute connected genome analysis, monitoring, and predictive simulation This technology enables a leading state-of-the-art wellness program for quality of life and longevity.",
    share_info:[
      {section: "Share Info", label: "Status", value: "Active"},
      {section: "Share Info", label: "Market Cap", value: "$ 19,212,500"},
      {section: "Share Info", label: "Shares Authorized", value: "910,000,000"},
      {section: "Share Info", label: "Shares Outstanding", value: "362,500,004"},
      {section: "Share Info", label: "Shares Outstanding", value: "Date 12/02/2019"},
      {section: "Share Info", label: "Shareholder Count", value: "70"},
      {section: "Share Info", label: "Shareholder Count Date ",  value: "12"},
      {section: "Share Info", label: "Short Interest",  value: "12,232"},
      {section: "Share Info", label: "Short Interest Date ", value: "11/15/2019"},
    ],
    reporting_info:[
      {section: "Reporting Info", label: "Reporting Status", value: "Alternative Reporting Standard"},
      {section: "Reporting Info", label: "Bankrupt", value: "No"},
      {section: "Reporting Info", label: "Shell", value: "No"},
      {section: "Reporting Info", label: "Audit Status", value: "Yes"},
      {section: "Reporting Info", label: "Auditor", value: ""},
      {section: "Reporting Info", label: "Auditor Address", value: ""},
      {section: "Reporting Info", label: "Auditor Website", value: ""},
      {section: "Reporting Info", label: "IR Firm", value: "Public Communications Company"},
      {section: "Reporting Info", label: "IR Firm Address", value: "-"},
      {section: "Reporting Info", label: "IR Firm Website", value: "http://mgapllc.com"},
      {section: "Reporting Info", label: "Legal Counsel", value: "TroyGould PC"},
      {section: "Reporting Info", label: "Legal Counsel Address", value: "1801 Century Park East, Los Angeles, CA 90067-2367, USA"},
      {section: "Reporting Info", label: "Legal Counsel Website", value: "http://www.troygould.com/"},
      {section: "Reporting Info", label: "Fiscal Year End", value: "4/30"},
      {section: "Reporting Info", label: "ADR Ratio", value: "-"},
      {section: "Reporting Info", label: "Transfer Agent", value: "VStock Transfer LLC"},
      {section: "Reporting Info", label: "Transfer Agent Address", value: "18 Lafayette Place,Woodmere, NY 11598, USA"},
      {section: "Reporting Info", label: "Depository Website", value: "-"},
      {section: "Reporting Info", label: "SHO Flag", value: "-"},
      {section: "Reporting Info", label: "3210 Flag", value: "-"},
    ],
    company_info:[
      {section: "Company Info", label: "Ticker Symbol", value: "USOTC:WMGR"},
      {section: "Company Info", label: "OTC Market Tier", value: "Pink No Information"},
      {section: "Company Info", label: "Security Type", value: "Common Stock"},
      {section: "Company Info", label: "CIK Number", value: "0001527974"},
      {section: "Company Info", label: "Address", value: "17011 Beach Blvd. 9th Floor, Huntington Beach, California 92647"},
      {section: "Company Info", label: "Country", value: "USA"},
      {section: "Company Info", label: "Phone", value: "310-990-0336"},
      {section: "Company Info", label: "Fax #", value: "-"},
      {section: "Company Info", label: "Website", value: "http://www.wellnessmatrixgroup.com"},
      {section: "Company Info", label: "SIC Code / Description", value: "6500 / Real Estate"},
      {section: "Company Info", label: "Key Executives", value: "Barry Migliorini - CEO, Joshua Patterson - President"},
      {section: "Company Info", label: "Number of Employees", value: "3"},
      {section: "Company Info", label: "Incorporation State NV"},
      {section: "Company Info", label: "Incorporation Country   USA"},
      {section: "Company Info", label: "Incorporation Year  2009"},
      {section: "Company Info", label: "Legal Counsel", value: "TroyGould PC"},
      {section: "Company Info", label: "Legal Counsel Address", value: "1801 Century Park East, Los Angeles, CA 90067-2367, USA"},
      {section: "Company Info", label: "Legal Counsel Website", value: "http://www.troygould.com/"},
    ]
  };
  visitYahooFin(){
    console.log('yahoo');
    window.open(
      'https://finance.yahoo.com/quote/wmgr/',
      '_blank' // <- This is what makes it open in a new window.
    );
  }

  // info: share info
  elements_share_info = this.investor_data.share_info.map(item => {

    let content = <div className="investor_data_row">
      <label className="investor_data_label">{item.label}</label>
      <span className="investor_data_value">{item.value}</span>
    </div>;
    return content;
  });
  // info: reporting info
  elements_reporting_info = this.investor_data.reporting_info.map(item => {

    let content = <div className="investor_data_row">
      <label className="investor_data_label">{item.label}</label>
      <span className="investor_data_value">{item.value}</span>
    </div>;
    return content;
  });
  // info: company info
  elements_company_info = this.investor_data.company_info.map(item => {

    let content = <div className="investor_data_row">
      <label className="investor_data_label">{item.label}</label>
      <span className="investor_data_value">{item.value}</span>
    </div>;
    return content;
  });

  /*
  items = this.press_data.map(item => {
    return <PressItem 
        key={item.id}
        title={item.title}
        link={item.link}
        date={item.date}
        teaser={item.teaser}
        />
  });
  */
  //<img className="content_image" src={kit}/>
  render() {
    return (
        <div>
          <div className="container banner_container banner_investors">
            <div className="container_message" >
            <div className="content_text_title">Investor Relations</div>
            <div className="content_text">
              Review our investor relations information below and reach out to us to learn more.            
            </div> 
            
              {/* <Button className="button_learn_more" intent="primary" icon="chevron-right"  onClick={this.visitYahooFin}>Learn More</Button> */}
              
            </div>
          </div>
        <div className="investor_relations_wrapper">
          <div className="investor_relations_description">
            <h3>Description</h3>
            {this.investor_data.description}
          </div>
          <div className="investor_data">
            <div className="investor_relations_section">
              <h3>Share Info</h3>
              {this.elements_share_info}
            </div>
            <div className="investor_relations_section">
              <h3>Reporting Info</h3>
              {this.elements_reporting_info}
            </div>
            <div className="investor_relations_section">
              <h3>Company Info</h3>
              {this.elements_company_info}
            </div>
          </div>
        </div>

        <div className="banner_callout light"><div className="banner_callout_text">

        <div>
        Investor Relations:
            Michael Selsman: www.publiccommunicationsco.com - 310-553-5732
        </div>
                 
        
        </div></div>

    </div>
    );
  }
}

export default Press;